import { TableConfig } from '@shared/interfaces/table/table-config';
import { PartySearchResult } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const actorTableConfig: TableConfig<PartySearchResult> = {
  id: 'actor-list',
  title: 'actorregister.title',
  selectable: true,
  selectableType: 'single',
  exportable: true,
  copyable: true,
  floatingHeader: true,
  pageSize: 25,
  pageSizeSelection: true,
  saveChanges: true,
  columns: [
    {
      title: 'actorregister.search.businessrole',
      key: 'businessRole',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'common.notspecified',
        balanceresponsibleparty: 'actor.businessrole.balanceresponsibleparty',
        gridaccessprovider: 'actor.businessrole.gridaccessprovider',
        balancesupplier: 'actor.businessrole.balancesupplier',
        imbalancesettlementresponsible: 'actor.businessrole.imbalancesettlementresponsible',
        meteringpointadministrator: 'actor.businessrole.meteringpointadministrator',
        systemoperator: 'actor.businessrole.systemoperator',
        metereddataresponsible: 'actor.businessrole.metereddataresponsible',
        balancepowersupplier: 'actor.businessrole.balancepowersupplier',
        metereddataaggregator: 'actor.businessrole.metereddataaggregator',
      }
    },
    {
      title: 'actorregister.search.name',
      key: 'name',
    },
    {
      title: 'actorregister.search.identification',
      key: 'identification',
    },
    {
      title: 'actorregister.search.terminationdate',
      key: 'terminationDate',
      cellRenderer: DateCellComponent,
    }
  ]
}
